import { ref, onMounted, onBeforeUnmount, computed } from 'vue'

export interface UseHeroVisibilityOptions extends IntersectionObserverInit {}

export function useHeroVisibility(
  selector = '#page-hero',
  options: UseHeroVisibilityOptions = {
    root: null,
    rootMargin: '0px 0px -80% 0px',
    threshold: 0
  }
) {
  const isHeroInView = ref(true)
  let observer: IntersectionObserver | undefined

  onMounted(() => {
    if (typeof window === 'undefined' || !selector) return

    const target = document.querySelector(selector)
    if (!target) return

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isHeroInView.value = entry.isIntersecting
      })
    }, options)

    observer.observe(target)
  })

  onBeforeUnmount(() => {
    if (observer) observer.disconnect()
  })

  const showSticky = computed(() => !isHeroInView.value)

  return { isHeroInView, showSticky }
}

export default useHeroVisibility
